if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = null;
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.cart = await this.getRenderableCart();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart?.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart?.renderContents) {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    } else {
                      window.location.href = routes.cart_url;
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart?.renderContents) {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              } else {
                window.location.href = routes.cart_url;
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        /* OctoCode */
          avaliableForPickupMessage();
        /* End OctoCode */
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        /* OctoCode */
        setTimeout(function(){
          avaliableForPickupMessage();
        }, 300);
        /* End OctoCode */
        return this.form.querySelector('[name=id]');
      }

      getCart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      async getRenderableCart() {
        let cart = this.getCart();
        if (!cart) return null;

        if (cart.tagName === 'CART-DRAWER' && typeof cart.renderContents !== 'function') {
          await customElements.whenDefined('cart-drawer');
          cart = this.getCart();
        }

        if (cart?.tagName === 'CART-NOTIFICATION' && typeof cart.renderContents !== 'function') {
          await customElements.whenDefined('cart-notification');
          cart = this.getCart();
        }

        return cart;
      }

      
    }
  );
}

/* OctoCode */
function isPickupOnlyVariant(value) {
  const normalizedValue = (value || '').toLowerCase();
  return normalizedValue.includes('15-gal')
    || normalizedValue.includes('15 gallons')
    || normalizedValue.includes('15gallons');
}

function avaliableForPickupMessage() {
  let productData2 = document.getElementById("product-data");
  const pickupWarning = document.getElementById('pickup-warning');
  if (!productData2 || !pickupWarning) return;
  let productTags2 = productData2.dataset.tags.split(',').map(tag => tag.trim());
  let hasPickupTag2 = productTags2.includes('only-pickup');
  if (hasPickupTag2) {
    let currVariant = $("variant-selects fieldset input:checked").val() || $(".product__title h1").text();
    if (!currVariant) return;
    $(`form[data-type='add-to-cart-form'] input[name="properties[Pickup]"]`).remove();
    if (isPickupOnlyVariant(currVariant)) {
      pickupWarning.style.display = 'block';
      $(`form[data-type='add-to-cart-form']`).append(`<input type="hidden" name="properties[Pickup]" value="Local pickup only">`);
    } else {
      pickupWarning.style.display = 'none';
    }
  }
}
/* End OctoCode */
